const parseUrl = (url) => {
  if (!url) return null;
  try {
    const parsed = new URL(url, window.location.origin);
    return ['http:', 'https:'].includes(parsed.protocol) ? parsed : null;
  } catch {
    return null;
  }
};

/** Returns true if the URL has an http or https protocol. */
export const isSafeUrl = (url) => parseUrl(url) !== null;

/** Safely navigates to a URL after validating the protocol. */
export const safeNavigate = (url) => {
  const parsed = parseUrl(url);
  if (parsed) {
    window.location.href = parsed.href;
  } else if (url) {
    console.error('safeNavigate: invalid URL', { url });
  }
};

/** Safely opens a URL in a new tab after validating the protocol. */
export const safeOpenNewTab = (url) => {
  const parsed = parseUrl(url);
  if (parsed) {
    window.open(parsed.href, '_blank', 'noopener,noreferrer');
  } else if (url) {
    console.error('safeOpenNewTab: invalid URL', { url });
  }
};
